var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cmp-site-container',[_c('mp-page-header',{attrs:{"title":"Clips","subtitle":"Manager Clips and view their streams"}}),_c('cmp-content-block',{attrs:{"title":"Clips"}},[_c('clips-clip-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }